import { makeStyles } from "@material-ui/core";

export const DetailCardStyles = makeStyles(() => ({
	denseCardHeader: {
		paddingBottom: 0,
	},
	sameLineLineItem: {
		marginLeft: 10,
	},
}));